import type { Suggestion } from '@wizbii/utils/models';

import { createReducer, on } from '@ngrx/store';
import { suggestionClear, suggestionGetEligibleSuccess } from '@stores/suggestion/suggestion-ngrx.action';

export const suggestionKey = 'suggestion';

export type SuggestionState = {
  suggestionIds: string[] | undefined;
  premiumSuggestions: Suggestion[] | undefined;
  notPremiumSuggestions: Suggestion[] | undefined;
  alreadyDepositSuggestions: Suggestion[] | undefined;
  totalReward: number | undefined;
};

export const initialState: SuggestionState = {
  suggestionIds: undefined,
  premiumSuggestions: undefined,
  notPremiumSuggestions: undefined,
  alreadyDepositSuggestions: undefined,
  totalReward: undefined,
};

export const suggestionReducer = createReducer(
  initialState,
  on(suggestionGetEligibleSuccess, (_, { suggestionListing }) => suggestionListing),
  on(suggestionClear, () => ({
    suggestionIds: undefined,
    premiumSuggestions: undefined,
    notPremiumSuggestions: undefined,
    alreadyDepositSuggestions: undefined,
    totalReward: undefined,
  }))
);
